import { PLATFORM_CRM_TABLE } from '@shared';
import { defaultCrmColumnConfig, parseCrmColumnConfig } from './crm-config';
import type { CrmColumnConfig } from './crm-config';

export type PlatformConfig = Omit<CrmColumnConfig, 'customerIdDigitLength'> & {
  customerIdDigitLength?: number;
};

export const defaultPlatformConfig: CrmColumnConfig = { ...defaultCrmColumnConfig, tableName: PLATFORM_CRM_TABLE };

export function parsePlatformConfig(value: unknown): CrmColumnConfig {
  const config = parseCrmColumnConfig(value);

  return { ...config, tableName: config.tableName || PLATFORM_CRM_TABLE };
}

export function isPlatformConfigComplete(config: CrmColumnConfig) {
  return Boolean(config.tableName && config.customerIdColumn && config.phoneMatchColumn);
}

export function platformConfigForSave(config: CrmColumnConfig): PlatformConfig {
  return {
    ...config,
    phoneUpdateColumns: config.phoneUpdateColumns?.length ? config.phoneUpdateColumns : undefined,
    fieldMappings: config.fieldMappings.filter((m) => m.crmField && m.variableName),
  };
}
